import React, { useEffect, useRef, useState } from "react";

function PenthouseBlock1({ rooms }) {
  const svgRef = useRef(null);
  const [roomCenters, setRoomCenters] = useState([]);
  const [clickedRoom, setClickedRoom] = useState(null);

  const handleBlockClick = (pathId) => {
    const room = rooms.find((room) => room.top === pathId);
    if (room) {
     
      setClickedRoom({ pathId, status: room.status });
    }
  };

useEffect(() => {
  if (svgRef.current) {
    const paths = svgRef.current.querySelectorAll("path");
    const centers = Array.from(paths).map((path) => {
      const bbox = path.getBBox();
      const centerX =
        path.id === "B1 - 01"
          ? 1070 // near the top edge
          : bbox.x + bbox.width / 2;

      // Conditionally shift label Y position for B1 - 01
      const centerY =
        path.id === "B1 - 01"
          ? 720
          : path.id === "B1 - 02"
          ? 480
          : bbox.y + bbox.height / 2; // default center

     
      return { centerX, centerY, pathId: path.id };
    });

    setRoomCenters(centers);
  }
}, [rooms]);

  return (
    <div className=" relative w-full h-full">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="50 300 1500 900"
        width="100%"
        height="100%"
        preserveAspectRatio="xMidYMid meet"
        ref={svgRef}
      >
        <defs />

        <path
          d="M 474,784 L 474,832 L 476,832 L 477,833 L 478,832 L 479,833 L 958,833 L 959,832 L 961,832 L 961,784 Z"
          fill="#ccc3c0"
          stroke-width="1"
        />
        <text x="700" y="814" font-size="12" fill="white" text-anchor="middle">
          2.0 M WIDE BALCONY
        </text>

        <path
          d="M 1393,743 L 1393,1097 L 1392,1098 L 1015,1098 L 1014,1097 L 1014,837 L 1013,836 L 965,836 L 965,1146 L 966,1147 L 1441,1147 L 1441,743 Z"
          fill="#ccc3c0"
          stroke-width="1"
        />
        <text
          x="1200"
          y="1125"
          font-size="12"
          fill="white"
          text-anchor="middle"
        >
          2.0 M WIDE BALCONY
        </text>
        <text
          x="830"
          y="425"
          font-size="12"
          fill="white"
          text-anchor="middle"
          transform="rotate(-90 1380 385)"
        >
          2.0 M WIDE BALCONY
        </text>

        <path
          id="B1 - 12"
          d="M 1239,743 L 1239,744 L 1238,745 L 1238,873 L 1236,875 L 1171,875 L 1169,873 L 1169,838 L 1168,837 L 1168,836 L 1018,836 L 1018,837 L 1017,838 L 1017,1092 L 1018,1093 L 1018,1094 L 1389,1094 L 1389,1080 L 1390,1079 L 1390,1074 L 1389,1073 L 1389,759 L 1390,758 L 1390,753 L 1389,752 L 1389,743 Z"
          stroke-width="1"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B1 - 12")}
          fill={
            clickedRoom?.pathId === "B1 - 12"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#baa9a7"
          }
        />
        <path
          id="B1 - 11"
          d="M 474,629 L 474,779 L 475,780 L 961,780 L 961,634 L 962,633 L 961,632 L 962,631 L 961,630 L 961,629 Z"
          stroke-width="1"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B1 - 11")}
          fill={
            clickedRoom?.pathId === "B1 - 11"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#baa9a7"
          }
        />
        <path
          id="B1 - 01"
          d="M 475,562 L 474,563 L 435,563 L 435,564 L 434,565 L 434,623 L 435,624 L 435,625 L 1170,625 L 1172,627 L 1172,633 L 1171,634 L 1171,635 L 1170,636 L 1168,636 L 1167,635 L 1167,629 L 968,629 L 967,628 L 966,629 L 965,629 L 965,832 L 967,832 L 968,833 L 1014,833 L 1015,832 L 1016,833 L 1164,833 L 1165,832 L 1167,832 L 1169,830 L 1171,830 L 1171,829 L 1172,828 L 1172,827 L 1171,826 L 1171,825 L 1169,825 L 1167,823 L 1167,814 L 1168,813 L 1170,813 L 1172,815 L 1171,816 L 1172,817 L 1172,818 L 1171,819 L 1171,821 L 1172,822 L 1171,823 L 1172,822 L 1171,821 L 1171,819 L 1172,818 L 1172,817 L 1171,816 L 1172,815 L 1172,814 L 1171,814 L 1170,813 L 1171,812 L 1171,811 L 1172,810 L 1171,809 L 1171,808 L 1170,807 L 1171,806 L 1172,806 L 1172,802 L 1171,801 L 1171,800 L 1172,799 L 1171,798 L 1172,799 L 1171,800 L 1171,801 L 1172,802 L 1172,805 L 1170,807 L 1168,807 L 1167,806 L 1167,797 L 1168,796 L 1170,796 L 1172,794 L 1172,793 L 1171,792 L 1171,791 L 1170,790 L 1172,788 L 1172,781 L 1171,780 L 1172,781 L 1172,788 L 1169,791 L 1167,789 L 1167,780 L 1169,778 L 1171,778 L 1171,777 L 1172,776 L 1171,775 L 1171,774 L 1170,773 L 1168,773 L 1167,772 L 1167,763 L 1168,762 L 1170,762 L 1171,763 L 1171,765 L 1172,766 L 1172,770 L 1171,771 L 1172,770 L 1172,766 L 1171,765 L 1171,763 L 1170,762 L 1172,760 L 1172,759 L 1171,758 L 1171,757 L 1170,756 L 1171,755 L 1172,755 L 1171,754 L 1171,753 L 1172,752 L 1172,748 L 1171,747 L 1171,746 L 1171,747 L 1172,748 L 1172,752 L 1171,753 L 1171,755 L 1169,757 L 1167,755 L 1167,745 L 1168,744 L 1171,744 L 1171,742 L 1172,741 L 1171,740 L 1171,739 L 1169,739 L 1167,737 L 1167,729 L 1168,728 L 1169,728 L 1170,727 L 1171,727 L 1171,726 L 1172,725 L 1171,724 L 1171,722 L 1168,722 L 1167,721 L 1167,711 L 1168,710 L 1171,710 L 1171,709 L 1172,708 L 1171,707 L 1171,705 L 1170,705 L 1169,704 L 1168,704 L 1167,703 L 1167,695 L 1169,693 L 1171,693 L 1171,692 L 1172,691 L 1172,690 L 1171,689 L 1171,688 L 1169,688 L 1167,686 L 1167,677 L 1168,676 L 1170,676 L 1172,678 L 1172,680 L 1171,681 L 1171,683 L 1172,684 L 1172,685 L 1171,686 L 1172,685 L 1172,684 L 1171,683 L 1171,681 L 1172,680 L 1172,677 L 1171,677 L 1170,676 L 1171,675 L 1172,675 L 1172,674 L 1171,673 L 1171,671 L 1170,670 L 1171,669 L 1171,667 L 1172,666 L 1171,665 L 1172,664 L 1172,663 L 1171,662 L 1171,661 L 1172,660 L 1171,661 L 1171,662 L 1172,663 L 1172,664 L 1171,665 L 1172,666 L 1171,667 L 1171,669 L 1170,670 L 1168,670 L 1167,669 L 1167,660 L 1168,659 L 1170,659 L 1172,657 L 1171,656 L 1171,654 L 1169,654 L 1167,652 L 1167,643 L 1168,642 L 1170,642 L 1171,643 L 1171,645 L 1172,646 L 1172,648 L 1171,649 L 1171,652 L 1171,649 L 1172,648 L 1172,646 L 1171,645 L 1171,644 L 1172,643 L 1171,643 L 1170,642 L 1171,641 L 1171,640 L 1172,639 L 1171,638 L 1171,637 L 1170,636 L 1171,635 L 1171,634 L 1172,633 L 1172,627 L 1171,626 L 1171,625 L 436,625 L 434,623 L 434,565 L 436,563 L 474,563 L 475,562 L 476,563 L 480,563 L 481,562 L 480,563 L 476,563 Z"
          stroke-width="1"
          fill="#8a8ca7"
        />
        <path
          id="B1 - 02"
          d="M 720,408 L 720,559 L 1233,559 L 1234,560 L 1237,560 L 1238,561 L 1238,737 L 1239,738 L 1239,739 L 1389,739 L 1389,725 L 1390,724 L 1390,720 L 1389,719 L 1389,408 Z"
          stroke-width="1"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B1 - 02")}
          fill={
            clickedRoom?.pathId === "B1 - 02"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#a8908c"
          }
        />
        <path
          id="B1 - 03"
          d="M 212,408 L 212,410 L 211,411 L 211,778 L 212,779 L 212,780 L 470,780 L 470,629 L 434,629 L 433,628 L 432,628 L 431,627 L 431,561 L 432,560 L 433,560 L 434,559 L 470,559 L 470,409 L 469,408 Z"
          stroke-width="1"
          style={{ cursor: "pointer" }}
          onClick={() => handleBlockClick("B1 - 03")}
          fill={
            clickedRoom?.pathId === "B1 - 03"
              ? clickedRoom.status === "AVAILABLE"
                ? "green"
                : clickedRoom.status === "BOOKED"
                ? "#cdca5c"
                : "red"
              : "#a8908c"
          }
        />

        <path
          d="M 720,356 L 720,404 L 721,404 L 722,405 L 1391,405 L 1393,407 L 1393,739 L 1441,739 L 1441,737 L 1442,736 L 1441,735 L 1441,364 L 1442,363 L 1442,359 L 1441,358 L 1441,356 Z"
          fill="#ccc3c0"
          stroke-width="1"
        />
        <text x="1080" y="385" font-size="12" fill="white" text-anchor="middle">
          2.0 M WIDE BALCONY
        </text>
        <text
          x="1210"
          y="425"
          font-size="12"
          fill="white"
          text-anchor="middle"
          transform="rotate(-90 1380 385)"
        >
          2.0 M WIDE BALCONY
        </text>

        <path
          d="M 159,356 L 159,832 L 160,832 L 161,833 L 463,833 L 464,832 L 465,833 L 468,833 L 469,832 L 470,832 L 470,784 L 210,784 L 208,782 L 208,778 L 207,777 L 207,416 L 208,415 L 208,406 L 209,405 L 212,405 L 213,404 L 214,405 L 468,405 L 469,404 L 470,404 L 470,356 Z"
          fill="#ccc3c0"
          stroke-width="1"
        />
        <text
          x="200"
          y="590"
          font-size="12"
          fill="white"
          text-anchor="middle"
          transform="rotate(-90, 200, 600)"
        >
          2.0 M WIDE WADI VIEW BALCONY
        </text>

        <path
          id="B1 - 04"
          d="M 483,353 L 482,354 L 482,355 L 481,356 L 476,356 L 476,558 L 481,558 L 482,559 L 482,560 L 483,561 L 483,562 L 487,562 L 487,561 L 488,560 L 488,559 L 489,558 L 498,558 L 500,560 L 500,561 L 501,562 L 505,562 L 506,563 L 505,562 L 505,560 L 507,558 L 515,558 L 516,559 L 516,560 L 517,561 L 517,562 L 521,562 L 521,561 L 522,560 L 522,559 L 523,558 L 533,558 L 534,559 L 534,561 L 535,562 L 539,562 L 539,560 L 541,558 L 549,558 L 551,560 L 551,562 L 550,563 L 545,563 L 544,562 L 541,562 L 544,562 L 545,563 L 550,563 L 551,562 L 556,562 L 556,560 L 558,558 L 567,558 L 568,559 L 568,560 L 569,561 L 569,562 L 573,562 L 574,563 L 575,562 L 583,562 L 575,562 L 574,563 L 573,562 L 573,560 L 575,558 L 583,558 L 585,560 L 585,561 L 586,562 L 590,562 L 591,563 L 592,562 L 593,563 L 594,563 L 595,562 L 599,562 L 600,563 L 601,562 L 600,563 L 599,562 L 595,562 L 594,563 L 593,563 L 592,562 L 591,563 L 590,562 L 590,560 L 592,558 L 601,558 L 602,559 L 602,560 L 603,561 L 603,562 L 607,562 L 607,561 L 608,560 L 608,559 L 609,558 L 618,558 L 619,559 L 619,560 L 620,561 L 620,562 L 624,562 L 624,561 L 625,560 L 625,559 L 626,558 L 635,558 L 637,560 L 637,562 L 641,562 L 641,561 L 642,560 L 642,559 L 643,558 L 652,558 L 653,559 L 653,560 L 654,561 L 654,562 L 658,562 L 658,561 L 659,560 L 659,559 L 660,558 L 669,558 L 671,560 L 671,562 L 675,562 L 676,561 L 676,559 L 677,558 L 686,558 L 688,560 L 688,562 L 692,562 L 692,561 L 693,560 L 693,559 L 694,558 L 703,558 L 705,560 L 705,561 L 706,562 L 710,562 L 710,560 L 712,558 L 715,558 L 716,557 L 716,357 L 715,356 L 712,356 L 710,354 L 710,353 L 705,353 L 705,354 L 703,356 L 694,356 L 693,355 L 693,354 L 692,353 L 688,353 L 688,354 L 686,356 L 678,356 L 676,354 L 676,353 L 671,353 L 671,354 L 669,356 L 660,356 L 659,355 L 659,354 L 658,353 L 654,353 L 654,354 L 652,356 L 644,356 L 641,353 L 637,353 L 637,354 L 635,356 L 626,356 L 624,354 L 624,353 L 620,353 L 620,354 L 618,356 L 609,356 L 607,354 L 607,353 L 603,353 L 603,354 L 601,356 L 592,356 L 590,354 L 590,353 L 586,353 L 583,356 L 575,356 L 573,354 L 573,353 L 569,353 L 568,354 L 568,355 L 567,356 L 558,356 L 556,354 L 556,353 L 551,353 L 551,354 L 549,356 L 541,356 L 539,354 L 539,353 L 535,353 L 532,356 L 523,356 L 522,355 L 522,354 L 521,353 L 517,353 L 517,354 L 515,356 L 507,356 L 505,354 L 505,353 L 500,353 L 500,354 L 498,356 L 489,356 L 487,354 L 487,353 Z"
          stroke-width="1"
          fill="#8a8ca7"
        />
        {rooms?.map((roomSec, index) => {
          const { unit, room } = roomSec;
          const roomCenter = roomCenters.find(
            (center) => center.pathId === roomSec.top
          );

          return (
            roomCenter && (
              <text
                key={index}
                x={roomCenter.centerX}
                y={roomCenter.centerY}
                fontSize="20"
                fill="black"
                textAnchor="middle"
                dominantBaseline="middle"
                fontWeight="bold"
              >
                <tspan x={roomCenter.centerX} dy="-0.8em">
                  {unit}
                </tspan>
                <tspan x={roomCenter.centerX} dy="2em">
                  {room}
                </tspan>
              </text>
            )
          );
        })}
      </svg>
    </div>
  );
}

export default PenthouseBlock1;
